(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fa-collection-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fa-cintro-more')) {
    customElements.define(
      'fa-cintro-more',
      class extends HTMLElement {
        connectedCallback() {
          this.text = this.querySelector('.fa-cintro__text');
          this.button = this.querySelector('.fa-cintro__toggle');
          if (!this.text || !this.button) return;
          this.button.addEventListener('click', () => this.toggle());
          this.ro = new ResizeObserver(() => this.measure());
          this.ro.observe(this.text);
          this.measure();
        }

        disconnectedCallback() {
          if (this.ro) this.ro.disconnect();
        }

        measure() {
          if (this.classList.contains('is-open')) return;
          const clamped = this.text.scrollHeight > this.text.clientHeight + 2;
          this.classList.toggle('is-clamped', clamped);
          this.classList.toggle('is-short', !clamped);
          this.button.hidden = !clamped;
        }

        toggle() {
          const open = !this.classList.contains('is-open');
          this.classList.toggle('is-open', open);
          this.button.setAttribute('aria-expanded', String(open));
          this.button.querySelector('[data-label-more]').hidden = open;
          this.button.querySelector('[data-label-less]').hidden = !open;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fa-heritage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fa-heritage')) {
    customElements.define(
      'fa-heritage',
      class extends HTMLElement {
        connectedCallback() {
          const rooms = this.querySelectorAll('[data-fa-room]');
          this.setupDock([...rooms]);
          if (window.Shopify && window.Shopify.designMode) {
            rooms.forEach((r) => r.classList.add('is-lit'));
            return;
          }
          this.io = new IntersectionObserver(
            (entries) =>
              entries.forEach((e) => {
                if (!e.isIntersecting) return;
                e.target.classList.add('is-lit');
                this.io.unobserve(e.target);
              }),
            { threshold: 0.35 }
          );
          rooms.forEach((r) => this.io.observe(r));
        }
        setupDock(rooms) {
          const dock = this.querySelector('[data-fa-dock]');
          if (!dock || rooms.length < 2) return;
          const era = dock.querySelector('[data-fa-dock-era]');
          const name = dock.querySelector('[data-fa-dock-name]');
          const index = dock.querySelector('[data-fa-dock-i]');
          const steps = dock.querySelectorAll('[data-fa-step]');
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const visible = new Set();
          let current = 0;

          const show = (i) => {
            current = i;
            const r = rooms[i];
            era.textContent = r.dataset.faEra || '';
            name.textContent = r.dataset.faName || '';
            index.textContent = String(i + 1);
            steps[0].disabled = i === 0;
            steps[1].disabled = i === rooms.length - 1;
          };

          steps.forEach((b) =>
            b.addEventListener('click', () => {
              const j = Math.min(rooms.length - 1, Math.max(0, current + Number(b.dataset.faStep)));
              rooms[j].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
            })
          );

          // The room crossing the middle of the screen is the current one; the
          // pill only shows while a room is there.
          this.dockIo = new IntersectionObserver(
            (entries) => {
              entries.forEach((e) => {
                const i = rooms.indexOf(e.target);
                if (e.isIntersecting) {
                  visible.add(i);
                  show(i);
                } else {
                  visible.delete(i);
                }
              });
              const on = visible.size > 0;
              dock.classList.toggle('is-on', on);
              dock.inert = !on;
            },
            { rootMargin: '-45% 0px -45% 0px' }
          );
          rooms.forEach((r) => this.dockIo.observe(r));
          show(0);
        }

        disconnectedCallback() {
          this.io && this.io.disconnect();
          this.dockIo && this.dockIo.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fa-lineup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fa-lineup')) {
    customElements.define(
      'fa-lineup',
      class extends HTMLElement {
        connectedCallback() {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          const rows = this.querySelectorAll('[data-fa-row]');
          this.classList.add('is-armed');
          this.io = new IntersectionObserver(
            (entries) => {
              entries.forEach((e) => {
                if (!e.isIntersecting) return;
                e.target.classList.add('is-in');
                this.io.unobserve(e.target);
              });
            },
            { threshold: 0.25 }
          );
          rows.forEach((row) => this.io.observe(row));
          // The theme editor shows everything at once.
          if (window.Shopify && window.Shopify.designMode) rows.forEach((row) => row.classList.add('is-in'));
        }
        disconnectedCallback() {
          this.io && this.io.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fa-product-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fa-product-story')) {
    customElements.define(
      'fa-product-story',
      class extends HTMLElement {
        connectedCallback() {
          const body = this.querySelector('[data-fa-body]');
          const nav = this.querySelector('[data-fa-toc]');
          const list = this.querySelector('[data-fa-toc-list]');
          if (!body || !nav || !list) return;
          const heads = [...body.querySelectorAll('h2, h3')].filter((h) => h.textContent.trim());
          if (heads.length < 2) return;

          const links = heads.map((h, i) => {
            if (!h.id) h.id = 'fa-ps-' + i + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').slice(0, 40);
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = '#' + h.id;
            a.textContent = h.textContent.trim();
            li.appendChild(a);
            list.appendChild(li);
            return a;
          });
          nav.hidden = false;

          const setCurrent = (i) => links.forEach((a, j) => a.setAttribute('aria-current', i === j ? 'true' : 'false'));
          this.io = new IntersectionObserver(
            (entries) => {
              entries.forEach((e) => {
                if (e.isIntersecting) setCurrent(heads.indexOf(e.target));
              });
            },
            { rootMargin: '-15% 0px -70% 0px' }
          );
          heads.forEach((h) => this.io.observe(h));
        }
        disconnectedCallback() {
          this.io && this.io.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
